import { Action, Dispatch } from "redux";
import fetchWithUuid from "./fetchWithUuid";
import checkError from "./checkError";
import { actionTypes, apiStatuses, Deferred, productInfoDeferred, SendSms } from "./Actions";

const sendSms: SendSms = (email: string) => (
  dispatch: Dispatch<Action>
) => {
  const failedCallback = (data: any) => {
    dispatch({ type: actionTypes.SEND_SMS, status: apiStatuses.ERROR, data });
    return sendSmsDeferred.reject(data);
  };
  const sendSmsDeferred = new Deferred();
  dispatch({ type: actionTypes.SEND_SMS, status: apiStatuses.LOADING });

  productInfoDeferred.promise.then(productInfo => {
    fetchWithUuid(
      `/bestilling/c/${
        productInfo.owningClient
      }/api/v2/ff/sendSms.json?email=${encodeURIComponent(email)}`
    )
      .then(checkError)
      .then(res => res.json())
      .then(data => {
        dispatch({
          data,
          status: apiStatuses.SUCCESS,
          type: actionTypes.SEND_SMS
        });
        return sendSmsDeferred.resolve(data);
      })
      .catch(failedCallback);
  }, failedCallback);

  return sendSmsDeferred.promise;
};

export default sendSms;
